









import { Component, Vue } from 'vue-property-decorator';
import DemographicChart from '@/components/Charts/DemographicChart.vue';
import { DemographicTenant } from '@/ts/HococoInterfaces';

@Component({
    components: {
        DemographicChart,
    },
})
export default class ChartsDemo extends Vue {
    protected demographicTenants: DemographicTenant[];

    constructor() {
        super();
    }

    public created() {
        this.demographicTenants = [
            {
                age: 23,
                gender: 'male',
                socialClubs: [
                    'Beer Drinking',
                    'Cats',
                    'Automobiles',
                ],
                educations: [
                    'CBS',
                    'Copenhagen High',
                ],
            },
            {
                age: 37,
                gender: 'female',
                socialClubs: [
                    'Beer Brewing',
                    'Catnapping',
                    'Manualmobiles',
                ],
                educations: [
                    'Not CBS',
                    'Copenhagen Low',
                ],
            },
            {
                age: 37,
                gender: 'other',
                socialClubs: [
                    'Stealing',
                    'Raving',
                    'Horseriding',
                ],
                educations: [
                    'Street',
                ],
            },
            {
                age: 49,
                gender: null,
                socialClubs: [
                    'Stealing',
                    'Raving',
                    'Horseriding',
                ],
                educations: [
                    'Street',
                ],
            },
            {
                age: 110,
                gender: 'other',
                socialClubs: [
                    'Stealing',
                    'Raving',
                    'Horseriding',
                ],
                educations: [
                    'Street',
                ],
            },
            {
                age: 12,
                gender: 'other',
                socialClubs: [
                    'Nails',
                    'Hair',
                    'Turtles',
                ],
                educations: [
                    'AAU',
                    'Fredenstrand Gymnasium',
                ],
            },
            {
                age: null,
                gender: 'male',
                socialClubs: [
                    'Nails',
                    'Hair',
                    'Turtles',
                ],
                educations: [
                    'AAU',
                    'Fredenstrand Gymnasium',
                ],
            },
            {
                age: null,
                gender: 'other',
                socialClubs: [
                    'Nails',
                    'Hair',
                    'Turtles',
                ],
                educations: [
                    'AAU',
                    'Fredenstrand Gymnasium',
                ],
            },
        ];

    }
}
